<template>
    <div class="statistics">
        <div class="title">用户概况</div>
        <div class="warp-block">
             <User></User>
        </div>
    </div>
</template>
<script>
import User from './block-user.vue'
export default {
    components:{
        User:User,
    },
    props:{
      width:{
        type:Number,
        default:100
      }  
    },
    data: ()=>({
       list:[
         
       ]
    }),
    methods:{
        
    },
}
</script>
<style lang="scss" scoped>
    .statistics{
        background: #FFFFFF;
        border-radius: 10px;
        width:100%;
        padding:20px;
        box-sizing: border-box; 
    }
    .title{
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #323F51;
        letter-spacing: 0;
        line-height: 18px;
        font-weight: 600;
        margin-bottom: 20px;
    }
    .warp-block{
        width:100%;
    }
</style>
